module.exports = __webpack_public_path__ + "static/media/icon-video.03a3ba10.svg";